import React, { useEffect } from "react";
import { PageHeader } from "../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useGetOneUserQuery, useUserUpdateMutation } from "../../services/user";
import { UserForm } from "./UserForm";
import { useBasicDataQuery } from "../../services/basicData/basicData";

const UpdateUser = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const {
    data: basicDataRes,
    isLoading: basicDataLoading,
    isFetching: basicDataFetching,
  } = useBasicDataQuery();
  const basicData = basicDataRes?.data?.data ?? [];
  const {
    data: userRes,
    isLoading: userLoading,
    isFetching: userFetching,
  } = useGetOneUserQuery({ id });
  const userData = userRes?.data?.data ?? {};
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    setError: setFormError,
    reset,
  } = useForm({
    defaultValues: {
      city_id: 3,
      type: "employee",
      selectedGroups: [],
      system_ids: [],
    },
  });
  const loading =
    basicDataLoading || basicDataFetching || userLoading || userFetching;
  const { mutate: updateUser, isPending } = useUserUpdateMutation({
    setError: setFormError,
  });

  // Populate form with user data when it loads
  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      // Transform user data to match form structure
      const formData = {
        name_ar: userData.name_ar,
        name_en: userData.name_en,
        national_id: userData.national_id,
        nationality_code: userData.nationality_code,
        gender: userData.gender,
        phone: userData.phone,
        email: userData.email,
        job_id: userData.job_id,
        job_destination_id: userData.job_destination_id,
        sector_id: userData.sector_id,
        department_id: userData.department_id,
        city_id: userData.city_id || 3,
        type: userData.type,
        selectedGroups: userData.groups || [],
        system_ids: userData.system_ids || [],
        group_ids: userData.group_ids || [],
        service_center_id: userData.service_center_id || null,
        profile_image: userData.profile_image_url
          ? {
              uid: "-1", // unique id
              name: "profile.png", // displayed filename
              status: "done", // shows as uploaded
              url: userData.profile_image_url, // image URL
            }
          : undefined,
      };

      reset(formData);
    }
  }, [userData, reset]);

  const onInvalid = (errors) => {
    const firstError = Object.values(errors)[0]?.message;
    toast.error(firstError || t("PLEASE_FIX_FORM_ERRORS"));
  };

  const onSubmit = (data) => {
    // Transform the data for API submission
    const payload = {
      id: parseInt(id),
      ...data,
      // Convert selectedGroups array to the format expected by API
      groups: data.selectedGroups?.map((group) => group?.id) || [],
      // Remove selectedGroups from payload as it's transformed to groups
      selectedGroups: undefined,
    };

    // Remove undefined properties
    Object.keys(payload).forEach((key) => {
      if (payload[key] === undefined) {
        delete payload[key];
      }
    });

    updateUser(payload);
  };

  return (
    <div>
      <PageHeader
        title={t("UPDATE_USER")}

      />

      <div className="m-4">
        <form
          onSubmit={handleSubmit(onSubmit, onInvalid)}
          className="d-flex flex-column gap-4"
        >
          <UserForm
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            basicData={basicData}
            loading={loading}
          />

          <div>
            <Button variant="primary" type="submit" disabled={isPending}>
              {isPending && <Spinner size="sm" className="me-2" />}
              {t("UPDATE_USER")}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateUser;
